import { current } from "@reduxjs/toolkit";
import { generateUniqueId } from "../utils/generateUniqueId";


export const mainFeeder_01 = {
    type: "mf-01",
    phaseCount: 3,
    minCableSection: 6,// minimum kablo kesiti
    minBreakerCurrent: 40, // minimum kesici akımı
    notrSectionIsEqual: true, // notr kesiti eşit mi?
    notrSection: 6, // notr kesiti
    cableType: "NYY", // kablo tipi
    cableMaterial: "Cu", // kablo malzemesi
    cableLength: 10, // Kablo Uzunluğu
    cableCount: 1,
    //masterNodeId,

    breakers: {
        breaker1notrBreak: false,
        breaker1Curve: "C", // Kesici tipi
        breaker3notrBreak: true,
        minBreakerCurrent: 40, // minimum kesici akımı
        breaker3Curve: "B", // Kesici tipi
        shortCircuitCurCap: 10, // kısa devre akımı

    },

}
export const mainFeeder_03_a = {
    //cable1
    //breaker1 AOS
    //breaker2 YKŞ 
    type: "mf-03-a",
    phaseCount: 3,
    minCableSection: 6,// minimum kablo kesiti
    minBreakerCurrent: 40, // minimum kesici akımı
    notrSectionIsEqual: true, // notr kesiti eşit mi?
    notrSection: 6, // notr kesiti
    cableType: "NYY", // kablo tipi
    cableMaterial: "Cu", // kablo malzemesi
    cableLength: 10, // Kablo Uzunluğu
    cableLengthV: 5, // Kablo Uzunluğu
    cableLengthH: 5, // Kablo Uzunluğu
    cableCount: 1,
    cableHousing: "earth",
    housing: {
        name: "Sayaç Pano",
        type: "meterPanel"
    },
    //masterNodeId,

    breakers: {
        minBreakerCurrent: 40, // minimum kesici akımı
        shortCircuitCurCap: 10, // kısa devre akımı
        breaker1notrBreak: false,
        breaker1Curve: "C", // Kesici tipi
        sensitivity: 300, // Kesici tipi

    },

}
export const mainFeeder_03_b = {
    //cable2
    //breaker3 AOS
    //breaker4 YKŞ
    type: "mf-03-b",
    phaseCount: 3,
    minCableSection: 6,// minimum kablo kesiti
    minBreakerCurrent: 40, // minimum kesici akımı
    notrSectionIsEqual: true, // notr kesiti eşit mi?
    isEarth:true,
    notrSection: 6, // notr kesiti
    cableType: "NYY", // kablo tipi
    cableMaterial: "Cu", // kablo malzemesi
    cableLength: 3, // Kablo Uzunluğu
    cableCount: 1,
    cableHousing: "earth",
    housing: {
        name: "ZKT",
        type: "fuseBox",
        installedPower: 0,
        demandFactor: "60-40%",
        demandPower: 0,
        purposeOfUse: "Mesken"
    },
    //masterNodeId,

    breakers: {
        minBreakerCurrent: 40, // minimum kesici akımı
        shortCircuitCurCap: 10, // kısa devre akımı
        breaker3notrBreak: false,
        breaker3Curve: "B", // Kesici tipi
        sensitivity: 30, // Kesici tipi

    },

}
export const branchSocketMachine = {
    //cable2
    //breaker3 AOS
    //breaker4 YKŞ
    type: "branchSocketMachine",
    phaseCount: 1,
    minCableSection: 2.5,// minimum kablo kesiti
    minBreakerCurrent: 20, // minimum kesici akımı
    notrSectionIsEqual: false, // notr kesiti eşit mi?
    notrSection: 2.5, // notr kesiti
    cableType: "NYA", // kablo tipi
    cableMaterial: "Cu", // kablo malzemesi
    cableLength: 3, // Kablo Uzunluğu
    cableCount: 1,
    cableHousing: "pipe",
    housing: {
        name: "SigortaKutusu",
        type: "fuseBox"
    },
    //masterNodeId,

    breakers: {
        minBreakerCurrent: 16, // minimum kesici akımı
        shortCircuitCurCap: 3, // kısa devre akımı
        breaker1notrBreak: false,
        breaker1Curve: "B", // Kesici tipi
        current:16


    }
}
export const branchSocket = {
    //cable2
    //breaker3 AOS
    //breaker4 YKŞ
    id: generateUniqueId("branch"),
    type: "branchSocket",
    phaseCount: 1,
    minCableSection: 2.5,// minimum kablo kesiti
    minBreakerCurrent: 16, // minimum kesici akımı
    notrSectionIsEqual: false, // notr kesiti eşit mi?
    notrSection: 2.5, // notr kesiti
    cableType: "NYA", // kablo tipi
    cableMaterial: "Cu", // kablo malzemesi
    cableLength: 3, // Kablo Uzunluğu
    cableCount: 1,
    cableHousing: "pipe",
    housing: {
        name: "SigortaKutusu",
        type: "fuseBox"
    },
    //masterNodeId,

    breakers: {
        minBreakerCurrent: 16, // minimum kesici akımı
        shortCircuitCurCap: 3, // kısa devre akımı
        breaker1notrBreak: false,
        breaker1Curve: "B", // Kesici tipi
        current:16

    },

}
export const branchLight = {
    //cable2
    //breaker3 AOS
    //breaker4 YKŞ
    type: "branchLight",
    phaseCount: 1,
    minCableSection: 2.5,// minimum kablo kesiti
    minBreakerCurrent: 10, // minimum kesici akımı
    notrSectionIsEqual: false, // notr kesiti eşit mi?
    notrSection: 2.5, // notr kesiti
    cableType: "NYA", // kablo tipi
    cableMaterial: "Cu", // kablo malzemesi
    cableLength: 3, // Kablo Uzunluğu
    cableCount: 1,
    cableHousing: "pipe",
    housing: {
        name: "SigortaKutusu",
        type: "fuseBox"
    },
    //masterNodeId,

    breakers: {
        minBreakerCurrent: 10, // minimum kesici akımı
        shortCircuitCurCap: 3, // kısa devre akımı
        breaker1notrBreak: false,
        breaker1Curve: "B", // Kesici tipi
        current:10


    },

}